export function validaCpf(cpf) {
  // Remove caracteres não numéricos
  let strCPF = cpf.replace(/\D/g, "");

  // Verifica se tem 11 dígitos
  if (strCPF.length !== 11) return false;

  // Verifica se todos os dígitos são iguais
  if (/^(\d)\1{10}$/.test(strCPF)) return false;

  // Validação do primeiro dígito verificador
  let soma = 0;
  for (let i = 0; i < 9; i++) {
    soma += parseInt(strCPF.charAt(i)) * (10 - i);
  }
  let resto = 11 - (soma % 11);
  let digito1 = resto < 2 ? 0 : resto;

  // Validação do segundo dígito verificador
  soma = 0;
  for (let i = 0; i < 10; i++) {
    soma += parseInt(strCPF.charAt(i)) * (11 - i);
  }
  resto = 11 - (soma % 11);
  let digito2 = resto < 2 ? 0 : resto;

  // Verifica se os dígitos calculados são iguais aos dígitos do CPF
  return parseInt(strCPF.charAt(9)) === digito1 && parseInt(strCPF.charAt(10)) === digito2;
}
